






































import Vue, { PropType } from "vue"
import PCareerTemplate from "./career/PCareerTemplate.vue"
import SectionTitle from "~/components/guideline/util/SectionTitle.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import EditItemDescription from "~/components/guideline/util/EditItemDescription.vue"
import { UserProfileExperienceCorporationView } from "~/backendApis/viewModel/userProfileSearch"

export default Vue.extend({
  components: {
    SectionTitle,
    ConversionButton,
    PCareerTemplate,
    EditItemDescription,
  },
  props: {
    careers: {
      type: Array as PropType<UserProfileExperienceCorporationView[]>,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMultipleCareers(): boolean {
      return this.careers.length >= 2
    },
  },
  methods: {
    goToCreateForm() {
      this.$nuxt.$router.push({ path: "/profiles/edit/career" })
    },
    isInitiallyExpandedCareer(indexOfCareer: number): boolean {
      return indexOfCareer === 0
    },
    handleClickCareerDeleteButton(index: number) {
      this.$emit("click-career-delete-button", index)
    },
  },
})
